import React, { useEffect, useState } from "react";
import { Box, Typography, Link, Stack, CircularProgress } from "@mui/material";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import api from "../../services/api";

const OrderHistorySummary = () => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [orderCount, setOrderCount] = useState(null);

  useEffect(() => {
    if (!isAuthenticated || !user) return;

    const fetchOrders = async () => {
      try {
        const res = await api.get("/orders/my-orders");
        setOrderCount(res.data.length);
      } catch (err) {
        console.error("Failed to fetch user orders:", err);
        setOrderCount(0);
      }
    };

    fetchOrders();
  }, [user, isAuthenticated]);

  if (orderCount === null) {
    return (
      <Stack direction="row" spacing={2} alignItems="center">
        <ShoppingBagIcon color="action" sx={{ fontSize: 36 }} />
        <Box flexGrow={1}>
          <Box display="flex" alignItems="center" gap={1}>
            <CircularProgress size={16} />
            <Typography variant="body2" color="text.secondary">
              Loading your order history...
            </Typography>
          </Box>
        </Box>
      </Stack>
    );
  }

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <ShoppingBagIcon color="action" sx={{ fontSize: 36 }} />
      <Box flexGrow={1}>
        {orderCount > 0 ? (
          <>
            <Typography fontWeight="bold">
              You’ve placed {orderCount} {orderCount === 1 ? "order" : "orders"}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Thank you for celebrating life’s sweet moments with us 💖
            </Typography>
            <Link
              component="button"
              underline="hover"
              sx={{
                fontSize: "0.85rem",
                mt: 1,
                color: "#FD7762",
                fontWeight: 500,
              }}
              onClick={() => navigate("/order-history")}>
              View all orders
            </Link>
          </>
        ) : (
          <>
            <Typography fontWeight="bold">
              What?! You haven't placed an order yet? 🎂
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              You're seriously missing out on some sweet moments 🍰✨
            </Typography>
            <Link
              component="button"
              underline="hover"
              sx={{
                fontSize: "0.85rem",
                mt: 1,
                color: "#FD7762",
                fontWeight: 500,
              }}
              onClick={() => navigate("/shop")}>
              Hurry up, get started!
            </Link>
          </>
        )}
      </Box>
    </Stack>
  );
};

export default OrderHistorySummary;
